import type {
  CashMovementInput, CloseShiftInput, OpenShiftInput, Paginated,
  SaleDetail, SaleListItem, SaleReturnInput, ShiftStatus,
} from '@najah/core'
import { api } from './api'

export interface RegisterOption { id: string; code: string; nameAr: string }

export interface CurrentShift {
  id: string
  registerId: string
  registerName: string
  openingCash: number
  openedAt: string
  expectedCash: number
  salesTotal: number
  salesCount: number
}

export interface ShiftHistoryRow {
  id: string
  registerName: string
  userName: string | null
  status: ShiftStatus
  openingCash: number
  countedCash: number | null
  expectedCash: number | null
  difference: number | null
  openedAt: string
  closedAt: string | null
}

export const shiftsApi = {
  current: () => api<{ shift: CurrentShift | null; registers: RegisterOption[] }>('/shifts/current'),
  history: (page = 1, pageSize = 25) =>
    api<Paginated<ShiftHistoryRow>>('/shifts/history', { query: { page, pageSize } }),
  open: (body: OpenShiftInput) => api<CurrentShift>('/shifts/open', { method: 'POST', body }),
  close: (id: string, body: CloseShiftInput) =>
    api<{ countedCash: number; expectedCash: number; difference: number; salesTotal: number; salesCount: number }>(
      `/shifts/${id}/close`,
      { method: 'POST', body },
    ),
  cash: (id: string, body: CashMovementInput) =>
    api<{ expectedCash: number; salesTotal: number; salesCount: number }>(`/shifts/${id}/cash`, {
      method: 'POST',
      body,
    }),
}

export interface SaleListFilter {
  page?: number
  pageSize?: number
  from?: string
  to?: string
  shiftId?: string
  status?: string
  search?: string
}

export const salesApi = {
  list: (filter: SaleListFilter) =>
    api<Paginated<SaleListItem>>('/sales', { query: filter as Record<string, string | number | undefined> }),
  get: (id: string) => api<SaleDetail>(`/sales/${id}`),
  createReturn: (body: SaleReturnInput) =>
    api<{ id: string; total: number }>('/sales/returns', { method: 'POST', body }),
}
